// components/PaymentButton.tsx
import React from 'react';
import { motion } from 'framer-motion';
import Card from '@/components/ui/Card';

interface PaymentButtonProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'accent';
}

const PaymentButton: React.FC<PaymentButtonProps> = ({
  title,
  subtitle,
  icon,
  onClick,
  variant = 'primary'
}) => {
  const gradient = variant === 'primary'
    ? 'from-primary/20 via-primary/10 to-background'
    : 'from-accent/20 via-accent/10 to-background';

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
      className="h-full"
    >
      
      <Card
        className={`bg-background text-white transform ease-out border border-primary/20 h-full justify-center flex flex-col cursor-pointer backdrop-blur-sm transition-all duration-300`}
        onClick={onClick}
      >

        <div className="flex items-center justify-center">

          <div className="bg-white bg-opacity-20 p-3 rounded-2xl backdrop-blur">
            {icon}
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-lg font-semibold text-primary mb-2">{title}</h3>
          <p className="text-sm text-white text-opacity-70">{subtitle}</p>
        </div>


      </Card>
    </motion.div>
  );
};

export default PaymentButton;